export default "__VITE_ASSET__BPYF2kHA__"